// extracted by mini-css-extract-plugin
export default {"form":"ContactSupport_form__1iOcp","form-buttons-container":"ContactSupport_form-buttons-container__HuVCx"};